module.exports = __webpack_public_path__ + "static/02_mobile@2x-c45bdea39a0c50137f6d5dc0165171f5.png";